module.exports = __webpack_public_path__ + "img/pret-royal.cce04de7.jpg";